import(/* webpackMode: "eager" */ "/vercel/path0/components/Impressum.js")